import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';

import { BaseButtonDirective } from '../../base-button';
import type {
  RtButtonColorContextVariant,
  RtButtonVariant,
  RtInfoboxButtonVariant,
  RtWalkthroughButtonVariant,
} from '../../button.types';
import { ExtendableButton } from '../../button.types';

@Component({
  standalone: true,
  selector: `rt-button, a[rt-button]`,
  templateUrl: './button.component.html',
  styleUrls: [
    '../../styles/base.less',
    './button.component.less',
    '../../directives/button-loading/button-loading.directive.less',
    '../../directives/button-dropdown/button-dropdown-indicator.directive.less',
  ],
  // eslint-disable-next-line
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: ExtendableButton, useExisting: ButtonComponent }],
})
export class ButtonComponent extends BaseButtonDirective implements ExtendableButton {
  @Input() public variant:
    | RtButtonVariant
    | RtInfoboxButtonVariant
    | RtButtonColorContextVariant
    | RtWalkthroughButtonVariant = 'tertiary';

  @ViewChild('prefix', { static: true, read: ViewContainerRef })
  public prefix: ViewContainerRef;
  @ViewChild('suffix', { static: true, read: ViewContainerRef })
  public suffix: ViewContainerRef;
}
